/**
 * Fetches the current USD to INR exchange rate from the backend.
 *
 * - Sends a `GET` request to `/razorpay/getExchangeRate`.
 * - If successful, returns the dynamic exchange rate.
 * - On failure (network error or non-200 response), returns a fallback default value.
 *
 * @async
 * @function GetExchangeRate
 * @returns {Promise<{USD: number, INR: number, error?: boolean, msg?: string}>} A promise that resolves to:
 * - `USD`: The base value (always 1).
 * - `INR`: The equivalent INR value.
 * - `error` (optional): `true` if an error occurred.
 * - `msg` (optional): A message describing the error.
 *
 * @example
 * const rate = await GetExchangeRate();
 * console.log("INR:", rate.INR);
 */

const GetExchangeRate = async () => {
  const uri = `${process.env.REACT_APP_SERVER}/razorpay/getExchangeRate`;
  const option = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await fetch(uri, option);
    if (res.status === 200) {
      const data = await res.json();
      return { USD: 1, INR: data?.INR };
    } else {
      return { USD: 1, INR: 87 };
    }
  } catch (error) {
    console.log(error);
    return { USD: 1, INR: 87 };
  }
};

export default GetExchangeRate;
